import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface CardSummaryProps {
  summary: string;
  testId?: string;
  equalWidths?: boolean;
  sx?: object;
}

export const CardSummary = ({
  summary,
  testId,
  equalWidths = false,
  sx
}: CardSummaryProps): ReactNode => (
  <Box
    {...(testId ? { 'data-testid': testId } : {})}
    title={summary}
    sx={{
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      overflow: 'hidden',
      ...sx
    }}
  >
    {summary.split(' · ').map((part, index, parts) => (
      <Box
        key={index}
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexShrink: 1,
          minWidth: 0,
          ...(equalWidths && { maxWidth: '50%' })
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: '0.75rem',
            color: '#9ca3af',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {part}
        </Typography>
        {index < parts.length - 1 && (
          <Box
            sx={{
              width: 3,
              height: 3,
              borderRadius: '50%',
              backgroundColor: '#9ca3af',
              mx: 0.5,
              flexShrink: 0
            }}
          />
        )}
      </Box>
    ))}
  </Box>
);
